import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetFundraisingDates = () => {
  return useQuery({
    staleTime: 1000 * 60,
    cacheTime: 1000 * 60 * 5,
    queryKey: [QUERY_KEYS.fundraising.fundraising_dates],
    queryFn: () =>
      fundraisingService.fundraisingDates().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
